import { render, staticRenderFns } from "./InvoiceConfigSet.vue?vue&type=template&id=54bfcda0&scoped=true"
import script from "./InvoiceConfigSet.vue?vue&type=script&lang=js"
export * from "./InvoiceConfigSet.vue?vue&type=script&lang=js"
import style0 from "./InvoiceConfigSet.vue?vue&type=style&index=0&id=54bfcda0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bfcda0",
  null
  
)

export default component.exports